import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { connect, useSelector } from "react-redux";
import RadarPlot from "./RadarPlot";
import { setChartData } from "../../features/player/chartDataSlice";

const mapDispatch = { setChartData };

function BagsRadarPlot({ data }) {
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const hs = sport === "horseshoes";
  return (
    <div>
      <RadarPlot //REFACTOR THIS
        data={[
          {
            item: hs ? "2-R %" : "4 in %",
            user: data.displayName,
            bagPercent: hs ? data.ring2Percent : data.inFourPercent,
          },
          {
            item: hs ? "1-R %" : "In %",
            user: data.displayName,
            bagPercent: hs ? data.ring1Percent : data.inPercent,
          },
          {
            item: hs ? "0-R %" : "On %",
            user: data.displayName,
            bagPercent: hs ? data.ring1Percent : data.onPercent,
          },
          {
            item: hs ? "Miss %" : "Off %",
            user: data.displayName,
            bagPercent: data.offPercent,
          },
          {
            item: "Win %",
            user: data.displayName,
            bagPercent:
              data.totalWins > 0
                ? parseFloat(
                    ((data.totalWins + 0.5 * data.totalTies) /
                      data.totalMatches) *
                      100
                  ).toFixed(0)
                : 0,
          },
        ]}
      />
    </div>
  );
}

export default connect(null, mapDispatch)(BagsRadarPlot);
